@import './cms-badge.scss';

.badge-name {
    font-weight: var(--cms-heading-base-font-weight);
}

.close-button:focus-visible,
.badge-link:focus-visible {
  outline: px-to-rem(2) solid var(--cms-badge-focus-color);
  outline-offset: 0;
}